// extracted by mini-css-extract-plugin
export default {"NavRight":"Nav_NavRight__vDzGZ","ThemeIcon":"Nav_ThemeIcon__Sd3pP","Dark":"Nav_Dark__Z1RjN","nav-right":"Nav_nav-right__6I-Cj"};